import '../MainFrame.css';
import './Administracion.css'
import Inprogress from '../../../assets/mejoras/CampusF-360.png'


export default function Administracion() {
  return(
    <><div className='frame'>
    <img src={Inprogress} alt="Haciendo Mejoras" className='enreparacion'/>
 </div>
     {/*<div className='frame'>
      
       <div className='admin-title'>
        <h2>Tramites</h2>
        <p>Consulta tu estado contable, obtene certificados y otro tipo de consultas.</p>
      </div>
      <div className="admin-options">
        <div className="admin-col">
          <div className="admin-content">
          <div className="admin-subtitle">
              <h3 className='admin-tittle-text'>Tramites</h3>
          </div>
                <div className='admin-option'>
                  <h4 className="setpointer sethoveryellow">Baja temporal</h4>
                  <p>Solicita la baja temporal de tu carrera y suspende tu cursada.</p>
                </div>
                <div className='admin-option'>
                  <h4 className="setpointer sethoveryellow">Baja definitiva</h4>
                  <p>Solicita la baja temporal de tu carrera de forma definitiva.</p>
                </div>
          </div>
        </div>
        <div className="admin-col">
          <div className="admin-content">
          <div className="admin-subtitle">
              <h3 className='admin-tittle-text'>Certificados</h3>
          </div>
                <div className='admin-option'>
                  <h4 className="setpointer sethoveryellow">Analitico</h4>
                  <p>Solicita el certificado analitico de materias aprobadas.</p>
                </div>
                <div className='admin-option'>
                  <h4 className="setpointer sethoveryellow">Examen Final</h4>
                  <p>Solicita la constancia que certifica que rendiste un determinado examen final</p>
                </div>
          </div>
        </div>
        <div className='admin-col'>
          <div className="admin-content">
          <div className="admin-subtitle">
              <h3 className='admin-tittle-text'>Otros</h3>
          </div>
                <div className='admin-option'>
                  <h4 className="setpointer sethoveryellow">Pagos</h4>
                  <p>Verifica tu estado contable y abona las cuotas correspondientes.</p>
                </div>
                <div className='admin-option'>
                  <h4 className="setpointer sethoveryellow">Historial de solicitudes</h4>
                  <p>Verifica tus solicitudes anteriores y las soluciones que fueron brindadas.</p>
                </div>
          </div>
        </div>
      </div> 
    </div>*/}
    </>
  );
}